import {
  ActionField,
  ActionFieldProps,
  Field,
  useFormContext,
} from '@oscar/form';

import {
  Col,
  Input,
  InputNumber,
  Row,
  Space,
  Button,
  Form,
} from '@oscar/theme';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { FileUploaded, TextField, ReadOnlyInput } from 'common/components';
import FormList from 'common/components/FormList';
import { APIS } from 'common/constants/endpoints';
import { useAuth } from 'features/auth';
import { forEach, has, isArray, map, set } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import useStatus, {
  StatusInstance,
} from 'views/pages/create-instrulation/hooks/useStatus';
import CreateForm from './CreateForm';
import { ProposalResult } from './ProposalResult';
import { numberWithCommas } from 'features/insulation/utils';
import './style.scss';
import { useCallback } from 'react';
import { act } from 'react-dom/test-utils';
import { ModalContextProvider } from './ModalContext';
import { ShowContextProvider } from './ShowContext';

interface Props {
  statusRequest?: StatusInstance;
}
export interface Proposal {
  insulationMaterial: number;
  insulationWorkOtherDescription: string;
  measurement: number;
  metaCladding: number;
  quotedCost: number;
  size: number;
  unitOtherDescription: string;
  workItem: number;
  finalMeasurement?: number;
  finalCost?: number;
  itemDescription?: string;
  estimatedMeasurement?: number;
  uom?: number;
}

const PreparerField = (props: any) => {
  const { state, status } = props?.statusRequest;
  return (
    <TextField
      label="Proposal Preparer"
      value={
        state === 'EDIT' && status === 'PENDING_PROPOSAL'
          ? props.fullName
          : props?.value
      }
    />
  );
};

const ProposalItem = (item: Proposal) => {
  const [isVisible, setIsVisible] = useState(false);
  const [statusRequest] = useStatus();
  const [formContext] = useFormContext();
  const { submitQAQCsTime } = formContext.selectors?.getInitalValue() || {};
  const metaDataProposalDetail =
    formContext.selectors?.getDataByKey('metaDataProposalDetail') || {};
  const getPaintingWorkDetail =
    formContext.selectors?.getDataByKey('getPaintingWorkDetail') || {};

  const checkPaintingFinal = (statusRequestParam: any) => {
    return (
      statusRequestParam?.status.includes?.('PENDING_PAINTING') &&
      statusRequestParam?.state === 'EDIT' &&
      submitQAQCsTime?.submittedTime ===
        submitQAQCsTime?.needToSubmittedTime - 1
    );
  };

  if (!item) return <p>Empty</p>;
  return (
    <div className="value-service">
      {statusRequest?.type !== 'PAINTING' && (
        <>
          <div className="service-lable">
            <TextField label="" value={item?.insulationWorkOtherDescription} />
          </div>
          <div>
            {statusRequest?.status === 'PENDING_REINSTATEMENT' &&
            statusRequest?.state === 'EDIT' ? (
              <>
                <div className="value-item">
                  <Space>
                    <TextField
                      label=""
                      value={
                        item?.finalMeasurement
                          ? numberWithCommas(item?.finalMeasurement)
                          : 'Pending Update'
                      }
                    />
                    <TextField
                      label=""
                      value={
                        item?.finalMeasurement ? item?.unitOtherDescription : ''
                      }
                    />
                  </Space>
                </div>
                <TextField
                  label=""
                  value={
                    item?.finalCost
                      ? `RM ${numberWithCommas(item?.finalCost)}`
                      : 'Pending Update'
                  }
                />
              </>
            ) : (
              <>
                <div className="value-item">
                  <Space>
                    <TextField
                      label=""
                      value={
                        item?.finalMeasurement
                          ? numberWithCommas(item?.finalMeasurement)
                          : numberWithCommas(item?.measurement)
                      }
                    />
                    <TextField label="" value={item?.unitOtherDescription} />
                  </Space>
                </div>
                <TextField
                  label=""
                  value={`RM ${
                    item?.finalCost
                      ? numberWithCommas(item?.finalCost)
                      : numberWithCommas(item?.quotedCost)
                  }`}
                />
              </>
            )}
          </div>
        </>
      )}

      {statusRequest?.type === 'PAINTING' && (
        <>
          <div className="service-lable">
            <TextField label="" value={item?.itemDescription} />
          </div>
          <div>
            {checkPaintingFinal(statusRequest) ? (
              <>
                <div className="value-item">
                  <Space>
                    <TextField
                      label=""
                      value={
                        item?.finalMeasurement
                          ? numberWithCommas(item?.finalMeasurement)
                          : 'Pending Update'
                      }
                    />
                    <TextField
                      label=""
                      value={item?.finalMeasurement ? item?.uom : ''}
                      mappingData={getPaintingWorkDetail?.uom}
                    />
                  </Space>
                </div>

                <TextField
                  label=""
                  value={
                    item?.finalCost
                      ? `RM ${numberWithCommas(item?.finalCost)}`
                      : 'Pending Update'
                  }
                />
              </>
            ) : (
              <>
                <div className="value-item">
                  <Space>
                    <TextField
                      label=""
                      value={
                        item?.finalMeasurement
                          ? numberWithCommas(item?.finalMeasurement)
                          : numberWithCommas(item?.estimatedMeasurement)
                      }
                    />
                    <TextField
                      label=""
                      value={item?.uom}
                      mappingData={getPaintingWorkDetail?.uom}
                    />
                  </Space>
                </div>
                <TextField
                  label=""
                  value={`RM ${
                    item?.finalCost
                      ? numberWithCommas(item?.finalCost)
                      : numberWithCommas(item?.quotedCost)
                  }`}
                />
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

const QuotedCostField: React.FC<{ actionProps: ActionFieldProps }> = ({
  actionProps,
}) => {
  const arrayTotal =
    actionProps?.field?.getFieldsValue().proposalBillingDetail?.data;
  let result = 0;
  let countItem = 0;
  map(arrayTotal, (itemService: any) => {
    if (!!itemService?.quotedCost) {
      result += parseFloat(itemService.quotedCost);
      countItem++;
    }
  });

  useEffect(() => {
    actionProps?.field?.setFieldsValue(
      set({}, 'proposalBillingDetail.totalQuotedCost', result.toFixed(2)),
    );
  }, [result]);

  const checkIsEmptyList = (dataList: any) => {
    if (isArray(dataList) && dataList?.length > 0) {
      for (const i of dataList) {
        if (!has(i, 'temp')) {
          return false;
        }
      }
      return true;
    }
    return true;
  };

  if (checkIsEmptyList(arrayTotal)) {
    return null;
  }
  return (
    <Row gutter={12}>
      <Col span={12}>
        <div className="total-cost">
          <p>Total Quoted Cost (RM)</p>
          <Input
            value={`${numberWithCommas(result)} for ${countItem} line items`}
            readOnly={true}
          />
          <Field name={['proposalBillingDetail', 'totalQuotedCost']}></Field>
        </div>
      </Col>
    </Row>
  );
};

const FinalCostField: React.FC<{ actionProps: ActionFieldProps }> = ({
  actionProps,
}) => {
  const arrayTotal =
    actionProps?.field?.getFieldsValue().proposalBillingDetail?.data;
  let result = 0;
  let countItem = 0;
  map(arrayTotal, (itemService: any) => {
    if (itemService?.finalCost > 0) {
      result = +itemService.finalCost + result;
      countItem++;
    }
  });

  useEffect(() => {
    actionProps?.field?.setFieldsValue(
      set({}, 'proposalBillingDetail.totalFinalCost', result?.toFixed(2)),
    );
  }, [result]);

  return (
    <>
      <p>Total Final Cost (RM)</p>
      <Input
        value={`${numberWithCommas(result)} for ${countItem} line items`}
        readOnly={true}
      />
      <Field name={['proposalBillingDetail', 'totalFinalCost']}></Field>
    </>
  );
};

const isReadOnly = (statusRequest?: StatusInstance, isContractor?: boolean) => {
  if (statusRequest?.state === 'EDIT' && isContractor) {
    return false;
  }
  return true;
};

interface propsData {
  poNumber: string;
  handleMaxPoNumber: any;
  num: string;
  pocost: string;
  costnumber: string;
  // handleAdd: any;
  index: number;
  //handleRemove: any;
  showhide: boolean;
  handleChange: any;
  validationData: any;
}

const PoComponent: React.FC<propsData> = ({
  poNumber,
  handleMaxPoNumber,
  num,
  pocost,
  costnumber,
  /// handleAdd,
  index,
  // handleRemove,
  handleChange,
  showhide,
  validationData,
}: propsData) => {
  return (
    <div style={{ display: 'flex' }}>
      <Field
        name={['proposalBillingDetail', poNumber]}
        normalize={(e: any) => handleMaxPoNumber(e, 20)}
        rules={[
          {
            pattern: new RegExp(/^[0-9-+()]*$/),
            message: 'Field does not accept alphabet',
          },
          // {
          //   required: showhide ? false : true,
          //   message: 'Please fill Po Number or else delete it',
          // },
        ]}
        //hidden={showhide}
      >
        <Input
          style={{
            width: '95%',
          }}
          placeholder={num}
          type="text"
          // onChange={() => handleChange(index)}
        />
      </Field>
      <Field
        name={['proposalBillingDetail', pocost]}
        //hidden={showhide}
        rules={[
          {
            required: validationData ? true : false,
            message: 'Please fill pocost after filling Po Number',
          },
        ]}
      >
        <InputNumber
          placeholder={costnumber}
          min="0"
          decimalSeparator="."
          precision={2}
          style={{
            width: '95%',
          }}
        />
      </Field>
      {/* {index == 1 ? (
        <Button
          type="primary"
          className="btn-submit"
          size="large"
          onClick={() => handleAdd}
          icon={<PlusCircleOutlined />}
        ></Button>
      ) : (
        !showhide && (
          <Button
            type="primary"
            className="btn-submit"
            size="large"
            onClick={() => handleRemove(index)}
            icon={<MinusCircleOutlined />}
          ></Button>
        )
      )} */}
    </div>
  );
};
interface showData {
  one: boolean;
  two: boolean;
  three: boolean;
  four: boolean;
}

interface poArray {
  poNumber: string;
  poCost: number | '0' | undefined | string;
  id?: number;
  show?: boolean;
}

const PoNumberField: React.FC<{ actionProps: ActionFieldProps }> = ({
  actionProps,
}) => {
  const [formContext] = useFormContext();

  const item = formContext.selectors?.getInitalValue().proposalBillingDetail;
  const validationData =
    actionProps?.field?.getFieldsValue().proposalBillingDetail;

  const poArrayExist: poArray[] = [
    {
      poNumber: item?.poNumber,
      poCost: item?.poCost,
      id: 0,
    },
    {
      poNumber: item?.poNumber1,
      poCost: item?.poCost1,
      id: 1,
    },
    {
      poNumber: item?.poNumber2,
      poCost: item?.poCost2,
      id: 2,
    },
    {
      poNumber: item?.poNumber3,
      poCost: item?.poCost3,
      id: 3,
    },
  ];
  const filterPoArrayExist = poArrayExist.filter(element => {
    return element.poNumber !== null || element.poCost !== null;
  });

  const [show, setShow] = useState<boolean[]>([false, false, false, false]);

  const handleMaxPoNumber = (value: any, maxLength: any) => {
    if (value?.length <= maxLength) {
      return value;
    } else {
      return value?.substring(0, maxLength);
    }
  };

  // const handleAdd = () => {
  //   if (show.two === true) {
  //     setShow({ ...show, two: false });
  //   } else if (show.three === true) {
  //     setShow({ ...show, three: false });
  //   } else if (show.four === true) {
  //     setShow({ ...show, four: false });
  //   }
  // };

  // const handleRemove = (index: number) => {
  //   if (index === 2) {
  //     setShow({ ...show, two: true });
  //     actionProps?.field?.setFieldsValue(
  //       set({}, 'proposalBillingDetail.poNumber1', undefined),
  //     );
  //     actionProps?.field?.setFieldsValue(
  //       set({}, 'proposalBillingDetail.poCost1', undefined),
  //     );
  //   } else if (index === 3) {
  //     setShow({ ...show, three: true });
  //     actionProps?.field?.setFieldsValue(
  //       set({}, 'proposalBillingDetail.poNumber2', undefined),
  //     );
  //     actionProps?.field?.setFieldsValue(
  //       set({}, 'proposalBillingDetail.poCost2', undefined),
  //     );
  //   } else if (index === 4) {
  //     setShow({ ...show, four: true });
  //     actionProps?.field?.setFieldsValue(
  //       set({}, 'proposalBillingDetail.poNumber3', undefined),
  //     );
  //     actionProps?.field?.setFieldsValue(
  //       set({}, 'proposalBillingDetail.poCost3', undefined),
  //     );
  //   }
  // };

  const handleChange = (index: any) => {
    for (let i = 1; i <= 4; i++) {
      if (index === i) {
        show[i - 1] = true;
      }
    }
    setShow([...show]);
  };

  return (
    <>
      <Row gutter={20}>
        <Col span={24}>
          <div style={{ display: 'flex', gap: '35%' }}>
            <p>PO Number</p>
            <p>PO Cost</p>
          </div>

          <PoComponent
            index={1}
            handleChange={handleChange}
            poNumber="poNumber"
            num="PO Number 1"
            handleMaxPoNumber={handleMaxPoNumber}
            // handleAdd={handleAdd}
            //handleRemove={handleRemove}
            costnumber="PO Cost 1"
            pocost="poCost"
            showhide={show[0]}
            validationData={validationData?.poNumber}
          ></PoComponent>
          <PoComponent
            index={2}
            handleChange={handleChange}
            poNumber="poNumber1"
            num="PO Number 2"
            handleMaxPoNumber={handleMaxPoNumber}
            // handleAdd={handleAdd}
            //handleRemove={handleRemove}
            costnumber="PO Cost 2"
            pocost="poCost1"
            showhide={show[1]}
            validationData={validationData?.poNumber1}
          ></PoComponent>
          <PoComponent
            index={3}
            handleChange={handleChange}
            poNumber="poNumber2"
            num="PO Number 3"
            handleMaxPoNumber={handleMaxPoNumber}
            //handleAdd={handleAdd}
            //handleRemove={handleRemove}
            costnumber="PO Cost 3"
            pocost="poCost2"
            showhide={show[2]}
            validationData={validationData?.poNumber2}
          ></PoComponent>
          <PoComponent
            index={4}
            handleChange={handleChange}
            poNumber="poNumber3"
            num="PO Number 4"
            handleMaxPoNumber={handleMaxPoNumber}
            // handleAdd={handleAdd}
            // handleRemove={handleRemove}
            costnumber="PO Cost 4"
            pocost="poCost3"
            showhide={show[3]}
            validationData={validationData?.poNumber3}
          ></PoComponent>
        </Col>
      </Row>
    </>
  );
};
const ProposalDetail = ({ statusRequest }: Props) => {
  const [result, setResult] = useState<number>(0);
  const [formContext] = useFormContext();
  console.log(formContext.form?.getFieldsValue().proposalBillingDetail);
  const [auth] = useAuth();
  const { submitQAQCsTime } = formContext.selectors?.getInitalValue() || {};
  const metaDataProposalDetail =
    formContext.selectors?.getDataByKey('metaDataProposalDetail') || {};
  const getPaintingWorkDetail =
    formContext.selectors?.getDataByKey('getPaintingWorkDetail') || {};
  const arrayTotal = formContext?.form?.getFieldsValue([
    'proposalBillingDetail',
    'data',
  ]);
  let countItem = 0;
  useEffect(() => {
    map(arrayTotal.proposalBillingDetail.data, (itemService: any) => {
      if (itemService?.quotedCost && !itemService.isProposalList) {
        setResult(prev => prev + parseFloat(itemService.quotedCost));
        countItem++;
      }
    });
  }, []);

  console.log(result);

  const checkPaintingFinal = (statusRequestParam: any) => {
    return (
      statusRequestParam?.status.includes?.('PENDING_PAINTING') &&
      statusRequestParam?.state === 'EDIT' &&
      submitQAQCsTime?.submittedTime ===
        submitQAQCsTime?.needToSubmittedTime - 1
    );
  };
  const checkPaintingQAQCFinal = (statusRequestParam: any) => {
    return (
      statusRequestParam?.status?.includes?.('PENDING_QAQC') &&
      (submitQAQCsTime?.submittedTime ===
        submitQAQCsTime?.needToSubmittedTime - 1 ||
        submitQAQCsTime?.submittedTime === submitQAQCsTime?.needToSubmittedTime)
    );
  };
  console.log(formContext.form?.getFieldsValue().proposalBillingDetail);
  return (
    <ShowContextProvider>
      <ModalContextProvider>
        <div className="proposal-detail">
          <Row gutter={[20, 20]} className="headerComponent">
            <Col span={12}>
              <Field name={['proposalBillingDetail', 'proposalPreparer']}>
                <PreparerField
                  statusRequest={statusRequest}
                  fullName={auth.getUserInformation().fullName}
                />
              </Field>
            </Col>
            <Col span={12}>
              <Field name={'serviceProviderName'}>
                <TextField label="Service Provider" />
              </Field>
            </Col>
          </Row>
          <div className="notification-detail-title">
            {statusRequest?.type === 'PAINTING' ? 'Painting' : 'Insulation'}{' '}
            Service Detail
          </div>
          <FormList<Proposal>
            keyField="id"
            title={`${
              statusRequest?.type === 'PAINTING' ? 'Painting Work' : 'Work Item'
            } List`}
            allwayShowTitle={true}
            name={['proposalBillingDetail', 'data']}
            detailComponent={ProposalResult}
            onItemRenderer={ProposalItem}
            addedComponent={CreateForm}
            isAddedItemOnTop
            readOnly={isReadOnly(
              statusRequest,
              auth.getUserRoles().includes('CONTRACTOR'),
            )}
          />

          {statusRequest?.status === 'PENDING_PROPOSAL' ||
          statusRequest?.status === 'PENDING_REMOVAL' ||
          (statusRequest?.status === 'PENDING_REINSTATEMENT' &&
            statusRequest?.state === 'VIEW') ? (
            <>
              <ActionField
                name="totalQuotedCost"
                request={{
                  name: 'totalQuotedCost',
                }}
              >
                {(actionProps: ActionFieldProps) => (
                  <QuotedCostField actionProps={actionProps} />
                )}
              </ActionField>
            </>
          ) : (
            <></>
          )}

          {statusRequest?.status &&
            (['PENDING_REINSTATEMENT', 'BILLING'].includes(
              statusRequest?.status,
            ) ||
              checkPaintingQAQCFinal(statusRequest) ||
              checkPaintingFinal(statusRequest)) &&
            statusRequest?.state === 'EDIT' && (
              <div style={{ marginTop: '20px' }}>
                <Row gutter={12}>
                  {/* <Col span={12}>
                {/* <ActionField
                  name="poNumber"
                  request={{
                    name: 'poNumber',
                  }}
                >
                  {(actionProps: ActionFieldProps) => (
                    <PoNumberField actionProps={actionProps} />
                  )}
                </ActionField> 
              </Col> */}

                  <Col span={12}>
                    <ActionField
                      name="totalfinalCost"
                      request={{
                        name: 'totalfinalCost',
                      }}
                    >
                      {(actionProps: ActionFieldProps) => (
                        <FinalCostField actionProps={actionProps} />
                      )}
                    </ActionField>
                  </Col>
                </Row>
              </div>
            )}

          <Row gutter={12}>
            <Col span={24}>
              <FileUploaded
                readOnly={isReadOnly(
                  statusRequest,
                  auth.getUserRoles().includes('CONTRACTOR'),
                )}
                name={['proposalBillingDetail', 'attachments']}
                title="Attachment (optional)"
                request={{
                  name: 'attachments',
                  url: APIS.UPLOAD_FILE_TO_AZURE,
                  method: 'POST',
                }}
              />
            </Col>
          </Row>

          {statusRequest?.status === 'BILLING' &&
          statusRequest?.state === 'EDIT' ? (
            <div style={{ marginTop: '20px' }}>
              <Row gutter={12}>
                <Col span={12}>
                  <TextField
                    label="Billing Verifier Name"
                    value={auth.getUserInformation()?.fullName}
                  />
                </Col>
                <Col span={12}>
                  <p>Verified Final Cost (RM)</p>
                  <Field
                    name={['proposalBillingDetail', 'verifiedFinalCost']}
                    rules={[
                      {
                        required: true,
                        message:
                          'Please fill Verified Final Cost before submitting',
                      },
                    ]}
                  >
                    <InputNumber
                      placeholder="Verified Final Cost"
                      min="0"
                      decimalSeparator="."
                      precision={2}
                    />
                  </Field>
                </Col>
              </Row>
            </div>
          ) : (
            <>
              {(checkPaintingQAQCFinal(statusRequest) ||
                statusRequest?.status === 'BILLING' ||
                statusRequest?.status === 'CLOSED') && (
                <ActionField
                  name="viewBilling"
                  request={{
                    name: 'viewBilling',
                  }}
                >
                  {(actionProps: ActionFieldProps) => {
                    const item =
                      formContext.selectors?.getInitalValue()
                        .proposalBillingDetail;
                    return (
                      <div style={{ marginTop: '20px' }}>
                        <Row gutter={12}>
                          {/*<Col span={8}>
                         {item?.poNumber != null && (
                          <TextField
                            label="PO Number1"
                            value={item?.poNumber}
                          />
                        )}
                        {item?.poNumber1 != null && (
                          <TextField
                            label="PO Number2"
                            value={item?.poNumber1}
                          />
                        )}
                        {item?.poNumber2 != null && (
                          <TextField
                            label="PO Number3"
                            value={item?.poNumber2}
                          />
                        )}
                        {item?.poNumber3 != null && (
                          <TextField
                            label="PO Number4"
                            value={item?.poNumber3}
                          />
                        )}
                      </Col>
                      <Col span={8}>
                        {item?.poCost != null && (
                          <TextField label="Cost1" value={item?.poCost} />
                        )}
                        {item?.poCost1 != null && (
                          <TextField label="Cost2" value={item?.poCost1} />
                        )}
                        {item?.poCost2 != null && (
                          <TextField label="Cost3" value={item?.poCost2} />
                        )}
                        {item?.poCost3 != null && (
                          <TextField label="Cost4" value={item?.poCost3} />
                        )}
                      </Col> */}
                          <Col span={12}>
                            <TextField
                              label="Total Quoted Cost (RM)"
                              value={result}
                            />
                          </Col>

                          <Col span={8}>
                            <TextField
                              label="Total Final Cost (RM)"
                              value={numberWithCommas(item?.totalFinalCost)}
                            />
                          </Col>
                        </Row>
                        <br />
                        <Row gutter={12}>
                          <Col span={12}>
                            <TextField
                              label="Billing Verifier Name"
                              value={item?.verifierName}
                            />
                          </Col>
                          <Col span={12}>
                            <TextField
                              label="Verified Final Cost (RM)"
                              value={numberWithCommas(item?.verifiedFinalCost)}
                            />
                          </Col>
                        </Row>
                      </div>
                    );
                  }}
                </ActionField>
              )}
            </>
          )}
        </div>
      </ModalContextProvider>
    </ShowContextProvider>
  );
};

export default ProposalDetail;
